import React, { Component } from "react";
import {
    DataGrid,
    Editing,
    Column,
    Paging,
    Pager,
    FormItem,
} from "devextreme-react/data-grid";
import Form, { SimpleItem, Label } from "devextreme-react/form";
import { Button } from "devextreme-react";
import uiInfo from "../../ui-info";
import PaginaToolbar from "../../components/PaginaToolbar";
import { criarNbsDs } from "../../DataSources";


export default class NbsBox extends Component {
    constructor(props) {

        super(props);
        this._gridInstance = React.createRef();

        this.onAtualizandoRow = this.onAtualizandoRow.bind(this);

        this.state = {
            filtroCorrente: [],
            filtro: { nome: "", status: 0 },
        };
        this.filtrar = this.filtrar.bind(this);
        this.limparFiltro = this.limparFiltro.bind(this);
        this.onSelecionado = props.onSelecionado;
        this.usadoComoPesquisa = props.onSelecionado !== undefined;
        this.dataSource = criarNbsDs(props.codigoLcp116);


        this.novoNbs = this.novoNbs.bind(this);
    }

    onAtualizandoRow(e) {
        e.cancel = true;
        this.props.history.push("nbs/editar/" + e.data.id);
    }

    filtrar(e) {
        let filtro = this.state.filtro;

        let filtroCorrente = [];

        if (filtro.codigo !== undefined && filtro.codigo !== "" && filtro.codigo !== null) {
            filtroCorrente.push([["codigo", "=", filtro.codigo], "OR", ["codigoFormatado", "=", filtro.codigo]]);
        }

        if (filtro.descricao !== undefined && filtro.descricao !== "") {
            filtroCorrente.push(["descricao", "contains", filtro.descricao.trim()]);
        }

        this._gridInstance.instance.filter(
            filtroCorrente.length > 0 ? filtroCorrente : null
        );
    }

    limparFiltro(e) {
        this.setState({ filtro: { codigo: "", descricao: "" } });
        this.filtrar();
    }

    render() {
        return (
            <React.Fragment>
                <div className={"content-block dx-card responsive-paddings"}>
                    <form onSubmit={this.filtrar}>
                        <Form id="frmPesquisa" formData={this.state.filtro} colCount={6} labelLocation="top">

                            <SimpleItem dataField="codigo" colSpan={2}>
                                <Label text="Código" />
                            </SimpleItem>

                            <SimpleItem dataField="descricao" colSpan={4}>
                                <Label text="Descrição" />
                            </SimpleItem>
                        </Form>
                        <br />
                        <div style={{ marginTop: "10px" }}>
                            <div style={{ display: "inline-block" }}>
                                <Button
                                    width={120}
                                    text="Filtrar"
                                    type="success"
                                    onClick={this.filtrar}
                                />
                            </div>
                            <div style={{ display: "inline-block", marginLeft: "10px" }}>
                                <Button text="Limpar Filtro" onClick={this.limparFiltro} />
                            </div>
                        </div>
                    </form>
                    <br /> <br />
                    <PaginaToolbar titulo="Lista de NBS" novoCb={this.novoNbs.bind(this)} >
                        <DataGrid
                            ref={(grid) => (this._gridInstance = grid)}
                            dataSource={this.dataSource}
                            showBorders={true}
                            rowAlternationEnabled={true}
                            remoteOperations={true}
                            columnAutoWidth={true}
                            focusedRowEnabled={true}
                            wordWrapEnabled={window.innerWidth < 800}
                            filterSyncEnabled={true}
                            onEditingStart={this.onAtualizandoRow}>

                            <Editing
                                allowDeleting={!this.usadoComoPesquisa}
                                allowUpdating={!this.usadoComoPesquisa}
                                useIcons={true}
                                visible={!this.usadoComoPesquisa}
                            />

                            <Column
                                type="buttons"
                                fixed={true}
                                fixedPosition={"left"}
                                buttons={[
                                    "edit",
                                    "delete",
                                    {
                                        hint: "Selecionar",
                                        icon: "repeat",
                                        visible: this.usadoComoPesquisa,
                                        onClick: this.onSelecionado,
                                    },
                                ]}
                            />

                            <Column
                                dataField={"codigoFormatado"}
                                visibleIndex={1}
                                allowEditing={false}
                                caption={"Código"}
                                width={120}>
                                <FormItem visibleIndex={1} />
                            </Column>

                            <Column dataField={"descricao"} allowEditing={false} visible={true} />

                            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />

                            <Pager
                                showInfo={true}
                                showNavigationButtons={true}
                                showPageSizeSelector={true}
                                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                            />
                        </DataGrid>
                    </PaginaToolbar>
                </div>
            </React.Fragment>
        );
    }

    novoNbs() {
        this.props.history.push("nbs/novo");
    }

    componentDidUpdate() {
        this.dataSource = criarNbsDs(this.props.codigoLcp116);
    }
}
